
// This file is generated by the maven plugin com.axley.js-remodel.  Do not edit!!!

export class GenLegendType {
    static readonly GEOSERVER: GenLegendType = new GenLegendType('GEOSERVER');
    static readonly HARDCODED: GenLegendType = new GenLegendType('HARDCODED');

    public readonly name: string;

    private constructor(name: string) {
        this.name = name;
    }

    static forName(name: string) {
        if (name === 'GEOSERVER') return GenLegendType.GEOSERVER;
        if (name === 'HARDCODED') return GenLegendType.HARDCODED;
        throw new Error('Unexpected value for GenLegendType:' + name);
    }

    static values(): GenLegendType[] {
        return [
            GenLegendType.GEOSERVER,
            GenLegendType.HARDCODED,
        ];
    }

    toJSON(): string {
        return this.name;
    }

    toString(): string {
        return this.name;
    }
}

